import React from 'react';
import { Violator } from '@hpi-sox/hpstellar-core';

import { useIsPrivateStore, useUserReceived } from '../../../hooks/useUserData';

import './deal-violator.less';

export default ({
    message,
    variation = 'primary',
    small = true,
    style = { display: 'inline-block', marginBottom: '.25rem', padding: '.125rem' },
}) => {
    const isPrivateStore = useIsPrivateStore();
    const userReceived = useUserReceived();
    if (!message || isPrivateStore || !userReceived) {
        return null;
    }
    return (
        <Violator className="coupon-violator" variation={variation} small={small} style={style}>
            {message}
        </Violator>
    );
};
